import { translation } from './env';
import { setHighchartsAccessibilityLang, setHighchartsTimezone, } from './highcharts/highchart-init';
export function initChartLibEnvOptionsHighcharts() {
    setHighchartsTimezone();
    setHighchartsAccessibilityLang(translation());
}
//# sourceMappingURL=env-highcharts.js.map